import React from 'react'
import loader from '../../assets/images/loader.gif'

export default function Loader() {
  return (
    <div
      style={{
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
      }}
    >
      <img
        src={loader}
        alt="loader"
        style={{ width: '100px', height: 'auto' }}
      ></img>
    </div>
  )
}
